import React, { Component } from 'react';

import './landingPage.css';

class LandingPage extends Component {
  render() {
    return (
      <div className="LandingPage">
        <div className="LandingPageContainer">
          <div className="top">
            <p className="welcome-text">
              YOUR FITNESS<br />STARTS WITH ONE ACT.
            </p>
          </div>
          <div className="middle">
            <p className="welcome-caption">
              ACTFIT is your key to a world of personal training
              that will change the way you work out.
            </p>
            <p className="welcome-caption">COMING SOON.</p>
          </div>
          <div className="bottom" />
        </div>
      </div>
    );
  }
}

export default LandingPage;



// WEBPACK FOOTER //
// ./src/scenes/landingPage/index.js